import './Dashboard.scss';
import React, { useState, useRef, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Stack, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import company from '../../assets/images/company.svg';
import trader from '../../assets/images/trader.svg';
import verifier from '../../assets/images/verifier.svg';
import dashboard from '../../assets/images/dashboard.svg';
import activity from '../../assets/images/activity.svg';
import settings from '../../assets/images/settings.svg';
import Header from '../../components/header/Header';
import appapi from '../../api/apiClient';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useOutsideClick from '../../components/DetectOutsideClick';
import { initCompanyDetails, initUserData, updateSideMenuList } from '../../redux/features/authSlice';

//-------------------------------------------- custom tooltip imported from components ----------------------------------
import TooltipBox from '../../components/TooltipBox';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import { initCountryList, initDmaList, initGetDriverSearchByNameAndMobile, initGodownList, initProductList, initRouteList, initVehicleList } from '../../redux/features/layoutSlice';

const menuArr = [
  {
    id: 1,
    name: 'Dashboard',
    flag: true,
    icon: dashboard,
    route: '',
    isRoute: true,
    // moduleName: "product_Management",
  },
  {
    id: 2,
    name: 'Company Management',
    flag: true,
    icon: company,
    route: 'companyManagement',
    isRoute: true,
    moduleName: 'company_Management',
  },

  {
    id: 3,
    name: 'Trader Management',
    flag: true,
    icon: trader,
    route: 'trader',
    isRoute: true,
    moduleName: 'trader',
  },
  {
    id: 4,
    name: 'Verifier Management',
    flag: true,
    icon: verifier,
    route: 'verifier',
    isRoute: true,
    moduleName: 'verifier',
  },
  {
    id: 5,
    name: 'Activity Log',
    flag: true,
    icon: activity,
    route: 'activityLog',
    isRoute: true,
    moduleName: 'activityLog',
  },
  {
    id: 6,
    name: 'Settings',
    flag: true,
    icon: settings,
    route: 'settings',
    isRoute: true,
    moduleName: 'settings',
  },
];

export default function Dashboard() {
  const { user } = useSelector((state) => state.auth);
  const [sideMenuList, setSideMenuList] = useState(menuArr);
  const [expanded, setExpanded] = useState(false);

  const theme = useTheme();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const permission = useSelector((state) => state.auth.userPermission);

  const checkSubmenuHasPermission = (pr = []) => {
    // for (const p of pr) {
    //   if (permission && permission[p]?.viewAccess === '1') {
    //     return true;
    //   }
    // }
    return true;
  };

  //-------------------------------------------- handling submenu ------------------------------------------
  const [submenuOpen, setSubmenuOpen] = useState({});
  // const handleSubmenu = (e, id, submenuId) => {
  //   e.preventDefault();
  //   setExpanded(true);
  //   setSubmenuOpen((prevState) => ({
  //     ...prevState,
  //     [id]: submenuId,
  //   }));
  // };
  const handleSubmenu = (e, id, submenuId) => {
    e.preventDefault();
    setExpanded(true);

    setSubmenuOpen((prevState) => {
      const updatedState = { ...prevState };

      // Close the active submenu
      for (const menuId in updatedState) {
        if (menuId !== id.toString()) {
          updatedState[menuId] = false;
        }
      }
      // Open the new submenu
      updatedState[id] = submenuId;
      return updatedState;
    });
  };

  const isMobile = useMediaQuery('(max-width:1000px)');
  const boxRef = useRef();
  useOutsideClick(boxRef, () => isMobile && setExpanded(false));

  useEffect(() => {
    let arr = JSON.parse(JSON.stringify(sideMenuList));
    dispatch(updateSideMenuList([...arr]));
    // eslint-disable-next-line
  }, [sideMenuList]);

  useEffect(() => {
    dispatch(initCompanyDetails());
    dispatch(initCountryList());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let arr = [...menuArr];
    // let permissions = user?.permission;
    // arr.map((menu) => {
    //     let find = permissions?.find((permission) => permission.moduleName === menu.moduleName)
    //     if (find) {
    //         if (find.viewAccess === '0' && find.editAccess === '0' && find.deleteAccess === '0' && find.activateAccess === '0') {
    //             if (menu.moduleName === find.moduleName) {
    //                 menu.flag = false
    //             }
    //         } else {
    //             menu.flag = true
    //         }
    //     }
    // })
    setSideMenuList(arr);
    // eslint-disable-next-line
  }, [user]);

  //expand sidebar function
  const clickHamburger = (event) => {
    event.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <div className="dashboardContainer">
      <Stack direction="row">
        {/* hambergur navigation starts here */}
        <div
          ref={boxRef}
          onClick={(event) => event.stopPropagation()}
          className={expanded ? 'expandsideNav' : 'shrinksideNav'}
          style={{
            background: theme.palette.primary.light,
            width: expanded ? '200px' : '56px',
            position: isMobile ? 'fixed' : 'relative',
            top: '0',
            left: '0',
          }}
        >
          <Stack>
            <div
              className="hamburgerwrapper"
              style={{
                width: '56px',
                height: '56px',
                background: theme.palette.primary.light,
              }}
            >
              <IconButton
                onClick={clickHamburger}
                style={{ width: '40px', height: '40px' }}
              >
                <MenuIcon
                  className="svgIconsMenu"
                  color={theme.palette.secondary.main}
                />
              </IconButton>
            </div>
            <Stack
              sx={{
                height: isMobile ? 'calc(100vh - 56px)' : 'calc(100vh - 72px)',
                position: 'relative',
                display: isMobile && !expanded ? 'none' : 'initial',
              }}
            >
              {/* -------------------------------------------- testing changes ------------------------------------------ */}
              {sideMenuList?.map((menu, index) => {
                return menu.flag ? (
                  menu.isRoute === true ? (
                    menu?.name === 'Dashboard' ? (
                      <NavLink
                        key={index}
                        className={({ isActive }) => (isActive ? 'activeMenu' : 'inActiveMenu') + ' flex-aligncenter linkStyle ' + (menu.name === 'Settings' ? 'settingStyle' : '')}
                        style={{ textDecoration: 'none' }}
                        to={`/${menu.route}`}
                      >
                        <TooltipBox
                          key={index}
                          title={!expanded && menu.name}
                          placement="right"
                        >
                          <div className="menuStyle">
                            <img
                              src={menu.icon}
                              alt={menu.name}
                            />
                          </div>
                        </TooltipBox>
                        {expanded && <Typography className="menuName fs-12 fw-medium ff-Roboto expandedAnimation">{menu.name}</Typography>}
                      </NavLink>
                    ) : (
                      <NavLink
                        key={index}
                        className={({ isActive }) => (isActive ? 'activeMenu' : 'inActiveMenu') + ' flex-aligncenter linkStyle ' + (menu.name === 'Settings' ? 'settingStyle' : '')}
                        style={{ textDecoration: 'none' }}
                        to={`/${menu.route}`}
                      >
                        <TooltipBox
                          key={index}
                          title={!expanded && menu.name}
                          placement="right"
                        >
                          <div className="menuStyle">
                            <img
                              src={menu.icon}
                              alt={menu.name}
                            />
                          </div>
                        </TooltipBox>
                        {expanded && <Typography className="menuName fs-12 fw-medium ff-Roboto expandedAnimation">{menu.name}</Typography>}
                      </NavLink>
                    )
                  ) : checkSubmenuHasPermission(menu?.subMenu.map((res) => res.name) || []) ? (
                    <div>
                      <NavLink
                        className={({ isActive }) => (isActive ? 'activeMenu' : 'inActiveMenu') + ' flex-aligncenter linkStyle ' + (menu.name === 'Settings' ? 'settingStyle' : '')}
                        onClick={(e) => handleSubmenu(e, menu.id, !submenuOpen[menu.id])}
                        key={menu.id}
                        to={`/${menu.route}`}
                      >
                        <TooltipBox
                          key={index}
                          title={!expanded && menu.name}
                          placement="right"
                        >
                          <div className="menuStyle">
                            <img
                              src={menu.icon}
                              alt={menu.name}
                            />
                          </div>
                        </TooltipBox>
                        {expanded && (
                          <Typography className="menuName fs-12 fw-medium ff-Roboto expandedAnimation color-white">
                            {menu.name}
                            {/* --------------------------- dropdown and drop up icon change ---------------------- */}

                            {menu.subMenu && submenuOpen[menu.id] ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
                          </Typography>
                        )}
                      </NavLink>
                      {/* --------------------------- showing sub menu ---------------------- */}

                      {menu.subMenu && submenuOpen[menu.id] && expanded && (
                        <div>
                          {menu.subMenu
                            .filter((res) => permission[res.name]?.viewAccess === '1')
                            .map((SubItem) => (
                              <NavLink
                                key={SubItem.id}
                                className={({ isActive }) => (isActive ? 'activeMenu' : 'inActiveMenu') + ' flex-aligncenter linkStyle subMenuStyle'}
                                // className="flex-aligncenter linkStyle subMenuStyle"
                                style={{
                                  color: 'white',
                                  marginLeft: 50,
                                  paddingLeft: '1rem',
                                }}
                                to={`/${SubItem.route}`}
                              >
                                <Typography className="menuName fs-12 fw-medium ff-Roboto expandedAnimation">{SubItem.name}</Typography>
                              </NavLink>
                            ))}
                        </div>
                      )}
                    </div>
                  ) : null
                ) : (
                  ''
                );
              })}
            </Stack>
          </Stack>
        </div>

        <div style={{ flex: '1', width: `calc(100%  - 256px)` }}>
          <Header />
          <Outlet />
        </div>
      </Stack>
    </div>
  );
}
